<template>
	<div class="the-navbar__user-meta flex items-center p-8" v-if="activeUserInfo.displayName">
		<vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
			<div class="flex justify-center items-center">
				<div class="con-img">
					<img
						v-if="activeUserInfo.photoURL"
						key="onlineImg"
						alt="user-img"
						width="40"
						height="40"
						class="rounded-full shadow-md cursor-pointer block"
						:src="avatar"
					/>
				</div>
				<vs-dropdown-menu class="vx-navbar-dropdown">
					<ul style="min-width: 11rem">
						<li
							class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
							@click="$router.push(`/apps/resource/resource-view/${activeUserInfo.datarutas_id}`)"
						>
							<feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
							<span class="ml-2">{{ $t("Profile") }}</span>
						</li>
						<li
							class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
							@click="$router.push('/dashboard/preferences').catch(() => {})"
						>
							<feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
							<span class="ml-2">{{ $t("Preferences.Preferences") }}</span>
						</li>
						<vs-divider class="m-1" />
						<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
							<feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
							<span class="ml-2">{{ $t("Logout") }}</span>
						</li>
					</ul>
				</vs-dropdown-menu>
				<div class="text-left leading-tight hidden sm:block pl-1" style="color: #2c2c2c">
					<p class="description-user">{{ activeUserInfo.name | capitalize }}</p>
					<small v-if="resource_data" class="g-label">{{ resource_data.alias | capitalize }}</small>
					<small v-else class="g-label">{{ activeUserInfo.datarutas_role_name | capitalize }}</small>
				</div>
			</div>
		</vs-dropdown>
	</div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import Api from "@/helpers/api.js";
import User from "@/models/User.js";
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";

// Store Module
import moduleResource from "@/store/resource/moduleResource.js";

export default {
	data() {
		return {
			avatar: require("@/assets/images/portrait/small/avatar-user-here.png"),
			user: new User(),
			resource_data: null,
		};
	},
	computed: {
		activeUserInfo() {
			return this.$store.state.AppActiveUser;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		async getResourceInfo() {
			const userSession = await this.user.getUser();

			const userId = userSession.id;
			const dataFilter = {
				ids: [userId],
			};
			this.$store
				.dispatch("moduleResource/fetchResourceFilterById", dataFilter)
				.then((res) => {
					this.resource_data = res.data.records[0];
					this.getResourcePhoto(this.resource_data.img_url);
				})
				.catch((err) => {
					throw new Error(err);
				});
		},
		getResourcePhoto(img_url) {
			const url = img_url;
			if (!url) {
				return;
			}
			downloadFileFromFirebase(url)
				.then((res) => {
					this.avatar = res;
				})
				.catch((error) => {});
		},
		logout() {
			// if user is logged in via auth0
			//if (this.$auth.profile) this.$auth.logOut();

			// if user is logged in via firebase
			const firebaseCurrentUser = firebase.auth().currentUser;

			if (firebaseCurrentUser) {
				firebase
					.auth()
					.signOut()
					.then(() => {});
			}

			// If JWT login
			if (localStorage.getItem("accessToken")) {
				this.openLoading();
				Api.delete("/auth/sessions/".concat(this.$store.state.AppActiveUser.access_token))
					.then((res) => {
						this.closeLoading();
						localStorage.removeItem("accessToken");
						// Change role on logout. Same value as initialRole of acj.js
						this.$acl.change("editor");
						localStorage.removeItem("userInfo");
						this.$router.push("/pages/login").catch(() => {});
						const user = new User();
						user.deleteUserIndexed().then((res) => {
							return res;
						});
					})
					.catch((err) => {
						this.closeLoading();
						localStorage.removeItem("accessToken");
						// Change role on logout. Same value as initialRole of acj.js
						this.$acl.change("editor");
						localStorage.removeItem("userInfo");
						this.$router.push("/pages/login").catch(() => {});
						throw new Error(err);
					});
			}

			// This is just for demo Purpose. If user clicks on logout -> redirect
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		this.getResourceInfo();
	},
};
</script>
